import React from 'react'
import TagDashboard from "./tag-dashboard";

const Tags = ({}) => {
    return (
        <>
            <TagDashboard/>
        </>
    )
}

export default Tags
